new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_header',
  data: {
    header: {
      useFirst: true, // first headerBar
      myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;
      isNavUp: true,
      isNavDown: true,
      isNavMin: false,
      lastScrollTop: 0,
      menuMobile: false,
      openCategorysMobile: false,
    },
    searchOpened: false,
    cartOpened: false,
  },
  methods: {
    addPaddingHeader() {
      const appHeader = document.querySelector('#app_header ');
      const header = document.querySelector('#app_header .header');
      const headerHeight = header.clientHeight;

      if (header && appHeader) {
        appHeader.style.height = headerHeight + 'px';
      }
    },
    runSpeechRecognition() {
      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        let output = document.querySelector(".output-search");
        let action = document.querySelector(".microphone");
        let inputMic = document.querySelector(".search__text");

        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;

        var recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = 'pt-BR';


        recognition.onstart = function () {
          if (!output.classList.contains("hide")) {
            output.classList.toggle("hide");
          }

          action.classList.toggle('active');
        };

        recognition.onspeechend = function () {

          action.classList.toggle('active');
          recognition.stop();
        }

        recognition.onresult = function (event) {
          var transcript = event.results[0][0].transcript;
          var confidence = event.results[0][0].confidence * 100;

          if (confidence < 50) {
            inputMic.classList.toggle('not-understand')
            output.classList.toggle("hide");
            inputMic.value = "Desculpe não entendi muito bem.";
          } else {
            inputMic.value = transcript
            document.querySelector('.search__submit').click()
          };

        };

        // start recognition
        recognition.start();
      } else return document.querySelector(".microphone-search").remove();
    },
    handleScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const scrollDifference = st - this.lastScrollTop;
      const customMobile = document.getElementById('custom-mobile-nav');
      const headerThird = document.getElementById('header-third');
      const quickMenu = document.getElementById('quick-menu-id');
      const whatsappWidget = document.getElementById('widget-whatsapp');

      if (st > this.lastScrollTop)
        this.header.isNavUp = false;
      else {
        if (st === 0)
          this.header.isNavUp = true;
      }

      if (st >= 90 && scrollDifference > 0) {
        this.header.isNavDown = false;
        this.header.isNavMin = true;

        if (customMobile)
          customMobile.classList.add('hide');

        if (headerThird)
          headerThird.classList.add('hide');

        if (quickMenu) {
          quickMenu.classList.add('hide');
          whatsappWidget.style.bottom = '';
        }

      } else {
        this.header.isNavDown = true;
        this.header.isNavMin = false;
        this.header.isNavMenuHide = false;

        if (customMobile)
          customMobile.classList.remove('hide');

        if (headerThird)
          headerThird.classList.remove('hide');

        if (quickMenu) {
          quickMenu.classList.remove('hide');
          whatsappWidget.style.bottom = '79px';
        }
      }

      this.lastScrollTop = st;
    },
    filterItems(item1, item2, item3, item4) {
      var data = [item1, item2, item3, item4];

      for (var i = 0; i < data.length; i++) {
        var element = document.querySelector('[item="' + data[i] + '"]');
        switch (data[i]) {
          case "home":
            element.setAttribute('href', '/');
            break;
          case "menu":
            var newSpan = document.createElement('span');
            newSpan.setAttribute('class', 'quick-menu__item--link toggleMenu js-mobile-nav-trigger');

            while (element.firstChild) {
              newSpan.appendChild(element.firstChild);
            }

            element.parentNode.replaceChild(newSpan, element);
            break;
          case "cart":
            element.setAttribute('href', '/carrinho');
            break;
          case "user":
            element.setAttribute('href', '/clientes/identificacao/?next=/clientes/minha-conta/');
            break;
          case "wishlist":
            element.setAttribute('href', '/clientes/minha-conta/minha-lista-de-produtos/');
            break;
        }
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.addPaddingHeader();

    let item1, item2, item3, item4

    if (document.getElementById('quick-item-1')) {
      item1 = document.getElementById('quick-item-1').getAttribute('item');
    }
    if (document.getElementById('quick-item-2')) {
      item2 = document.getElementById('quick-item-2').getAttribute('item');
    }
    if (document.getElementById('quick-item-3')) {
      item3 = document.getElementById('quick-item-3').getAttribute('item');
    }
    if (document.getElementById('quick-item-4')) {
      item4 = document.getElementById('quick-item-4').getAttribute('item');
    }

    if (item1 && item2 && item3 && item4) {
      this.filterItems(item1, item2, item3, item4);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    cartOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },

    searchOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  }
})
$(document).ready(function () {

  const searchOpen = document.querySelector('.header__second--search');
  const searchText = document.querySelector('.search__text');

  if (searchOpen && searchText) {
    searchOpen.addEventListener('click', function () {
      setTimeout(() => searchText.focus(), 50);
    });
  }

  const iconCart = document.querySelector('.cart-desktop');
  const cartPreview = document.querySelector('.cart-preview');
  const cartPreviewOverlay = document.querySelector('.cart-preview--overlay');
  if (iconCart && cartPreview && cartPreviewOverlay) {
    iconCart.addEventListener('click', () => {
      cartPreview.classList.toggle('active');
      cartPreviewOverlay.classList.toggle('active');
    });
  }

  const stopwatchElement = document.querySelector('.stopwatch-two');
  if (stopwatchElement) {
    const urlParametro = stopwatchElement.getAttribute('data-url') ? stopwatchElement.getAttribute('data-url').trim() : "";
    const hora = parseInt(stopwatchElement.getAttribute('data-hour'));
    const dia = parseInt(stopwatchElement.getAttribute('data-day'));
    const mes = parseInt(stopwatchElement.getAttribute('data-month'));
    const ano = parseInt(stopwatchElement.getAttribute('data-year'));

    // Verifique se os atributos necessários estão definidos e não são NaN
    if (!isNaN(hora) && !isNaN(dia) && !isNaN(mes) && !isNaN(ano)) {
      const urlAtual = window.location.pathname;
      let dataTermino;
      let cronometro;

      function atualizarCronometro() {
        const agora = new Date().getTime();
        const termino = dataTermino.getTime();
        const tempoRestante = termino - agora;

        if (tempoRestante >= 0) {
          const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
          const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
          const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);

          function formatarDigitos(numero) {
            // Formata o número com dois dígitos (exemplo: "08", "12")
            const numeroFormatado = numero.toString().padStart(2, '0');

            // Divide os dígitos e envolve cada um em uma tag <span>
            return `${numeroFormatado[0]}${numeroFormatado[1]}`;
          }

          const diasFormatado = formatarDigitos(dias);
          const horasFormatado = formatarDigitos(horas);
          const minutosFormatado = formatarDigitos(minutos);
          const segundosFormatado = formatarDigitos(segundos);

          document.getElementById("cronometro").innerHTML =
            diasFormatado + ' : ' + horasFormatado + ' : ' + minutosFormatado + ' : ' + segundosFormatado;
        } else {
          document.getElementById("cronometro").innerHTML = "Tempo esgotado!";
          clearInterval(cronometro);
        }
      }

      function mostrarCronometro() {
        dataTermino = new Date(ano, mes - 1, dia, hora, 0);
        cronometro = setInterval(atualizarCronometro, 1000);
      }

      // Mostrar cronômetro em todas as páginas se urlParametro estiver vazio
      if (urlParametro === "" || urlAtual.includes(urlParametro)) {
        mostrarCronometro();
      } else {
        stopwatchElement.style.display = 'none';
      }
    } else {
      console.error('Os atributos data-hour, data-day, data-month ou data-year estão ausentes ou inválidos.');
    }
  }

  var splideElement = document.querySelector('.faixa-topo');
  if (splideElement) {
    var splide = new Splide(splideElement, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      padding: { left: 0, right: 0 },
      arrows: false,
      pagination: false,
      autoplay: true,
    });

    splide.mount();
  }
})

var cart_preview_triggers = $('.header__second--tools-cart, .cart-preview-close, .cart-preview-header__close');

cart_preview_triggers.on("click", function (e) {
  if ($(window).width() >= 970) {
    // e.preventDefault();
  };

  $('.cart-preview--overlay').toggleClass('active');
  $('.cart-preview').toggleClass('active');
  // $('.cart-preview--overlay').addClass('active');
});

var cart_service = new CartService();
$('.delete-item').on('click', function (event) {
  cart_service.removeCartItem();
  window.sessionStorage.removeItem(`cart-preview-cache-${base_url}`);
});

if (window.outerWidth > 991) {
  $(".header__cart__wrap").click(function (e) {
    e.preventDefault();
    $('.cart-preview').addClass('active');
    $('.cart-preview--overlay').addClass('active');
  });

  $('.cart-preview--overlay').click(function (e) {
    e.preventDefault();
    $('.cart-preview').removeClass('active');
    $('.cart-preview--overlay').removeClass('active');
  })

  $('.cart-preview-header__close').click(function (e) {
    e.preventDefault();
    $('.cart-preview').removeClass('active');
    $('.cart-preview--overlay').removeClass('active');
  })
}


$(".cart-preview--close").click(function (e) {
  // e.preventDefault();
  // $('.cart-preview').removeClass('active');
  // $('.cart-preview--overlay').removeClass('active');
});

$(".cart-preview--overlay").click(function (e) {
  // e.preventDefault();
  // $('.cart-preview').removeClass('active');
  // $('.cart-preview--overlay').removeClass('active');
});

$(document).ready(function () {

  const help = document.querySelector('.help-me');
  if (help) {
    let helpGroupText = help.querySelector('.help-group-text');
    let helpContent = help.querySelector('.help-me-content');
    if (helpGroupText && helpContent) {
      helpGroupText.addEventListener('click', () => {
        helpGroupText.classList.toggle('active');
        helpContent.classList.toggle('active');
      })
    }
  }

  $(".mobile-nav__content--links").mCustomScrollbar({
    autoHideScrollbar: false,
    theme: "dark-3"
  });

})



